import {TENANT_BASE_URL} from "../../../common/Config/UrlHelper";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import {formatDateToLocal} from "../../../common/Helper/Support/DateTimeHelper";
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";

export default {
    mixins: [HelperMixin, DatatableHelperMixin],
    data() {
        return {
            options: {
                name             : this.$t('house-keeping'),
                url              : `${TENANT_BASE_URL}app/hotel/house-keeping-import`,
                showHeader       : true,
                tableShadow      : false,
                tablePaddingClass: 'pt-primary',
                columns          : [
                    {
                        title      : this.$t('date'),
                        type       : 'custom-html',
                        key        : 'date',
                        tdClassName: 'text-nowrap',
                        isVisible  : true,
                        modifier   : (value, row) => {
                            if (row.error && row.error.includes('date')) {
                                return '<span class="text-danger">' + formatDateToLocal(value) + '</span>'
                            }
                            return formatDateToLocal(value)
                        }
                    },
                    {
                        title    : this.$t('hotel'),
                        type     : 'custom-html',
                        key      : 'hotel',
                        isVisible: true,
                        modifier : (hotel) => {
                            return hotel ? '<span class="text-nowrap">' + hotel.name + '</span>' : '';
                        }
                    },
                    {
                        title    : this.$t('room_no'),
                        type     : 'custom-html',
                        key      : 'room_no',
                        isVisible: true,
                        modifier : (value, row) => {
                            if (row.error && row.error.includes('room_no')) {
                                return '<span class="text-danger">' + value + '</span>'
                            }
                            return value
                        }
                    },
                    {
                        title    : this.$t('primary_maid'),
                        type     : 'custom-html',
                        key      : 'primary_maid_id',
                        isVisible: true,
                        modifier : (value, row) => {
                            if (!row.primary_maid_name) {
                                return ''
                            }
                            if (row.error && row.error.includes('primary_maid_id')) {
                                return '<span class="text-danger">' + row.primary_maid_id + ' (' + row.primary_maid_name + ')</span>'
                            }
                            return row.primary_maid_id + ' (' + row.primary_maid_name + ')';
                        }
                    },
                    {
                        title    : this.$t('assistant_maid'),
                        type     : 'custom-html',
                        key      : 'assistant_maid_id',
                        isVisible: true,
                        modifier : (value, row) => {
                            if (!row.assistant_maid_name) {
                                return ''
                            }
                            if (row.error && row.error.includes('assistant_maid_id')) {
                                return '<span class="text-danger">' + row.assistant_maid_id + ' (' + row.assistant_maid_name + ')</span>'
                            }
                            return row.assistant_maid_id + ' (' + row.assistant_maid_name + ')';
                        }
                    },
                    {
                        title    : this.$t('staying'),
                        type     : 'custom-html',
                        key      : 'staying_status',
                        isVisible: true,
                        modifier : (value, row) => {
                            if (row.error && row.error.includes('staying_status')) {
                                return '<span class="text-danger">' + value + '</span>'
                            }
                            return value
                        }
                    },
                    {
                        title    : this.$t('cleaning'),
                        type     : 'custom-html',
                        key      : 'cleaning_status',
                        isVisible: true,
                        modifier : (value, row) => {
                            if (row.error && row.error.includes('cleaning_status')) {
                                return '<span class="text-danger">' + value + '</span>'
                            }
                            return value
                        }
                    },
                    {
                        title    : this.$t('option'),
                        type     : 'custom-html',
                        key      : 'options',
                        isVisible: true,
                        modifier : (value, row) => {
                            if (row.error && row.error.includes('options')) {
                                return '<span class="text-danger">' + value + '</span>'
                            }
                            return value
                        }
                    },
                    {
                        title    : this.$t('quantity'),
                        type     : 'custom-html',
                        key      : 'options_quantity',
                        isVisible: true,
                        modifier : (value, row) => {
                            if (row.error && row.error.includes('options_quantity')) {
                                return '<span class="text-danger">' + value + '</span>'
                            }
                            return value
                        }
                    },
                    {
                        title    : this.$t('start_time'),
                        type     : 'text',
                        key      : 'start_time',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('end_time'),
                        type     : 'text',
                        key      : 'end_time',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('confirmed'),
                        type     : 'custom-html',
                        key      : 'confirmed',
                        isVisible: true,
                        modifier : (value) => {
                            if (value) {
                                return '<span class="badge bg-success">ON</span>';
                            }
                            return '<span class="badge bg-danger">OFF</span>';
                        }
                    },
                    {
                        title    : this.$t('remark'),
                        type     : 'text',
                        key      : 'remark',
                        isVisible: true,
                    },
                ],
                filters          : [],
                paginationType   : "pagination",
                responsive       : true,
                rowLimit         : 10,
                showAction       : false,
                orderBy          : 'desc',
                actionType       : 'default',
                actions          : [],
            }
        }
    },
}